export default {
  zh: {
    export: '导出',
    selectObject: '选择类型',
    filteredBy: '过滤条件',
    selectFields: '选择字段',
    startExporting: '开始导出',
    exportHistory: '导出历史',
    exportRequestId: '导出请求号',
    objectType: '类型',
    exportDate: '导出日期',
    info: '信息',
    exportedBy: '导出者',
    status: '状态',
    clone: '复制',
    pin: '固定',
    unpin: '取消固定',
  },
  en: {
    export: 'Export',
    selectObject: 'Select Object',
    filteredBy: 'Filtered By',
    selectFields: 'Select Field',
    startExporting: 'Start Exporting',
    exportHistory: 'Export History',
    exportRequestId: 'Export Request ID',
    objectType: 'Object Type',
    exportDate: 'Export Date',
    info: 'Information',
    exportedBy: 'Exported By',
    status: 'Status',
    clone: 'Clone',
    pin: 'Pin',
    unpin: 'Unpin',
  }
};



// WEBPACK FOOTER //
// ./src/views/Setup/ObjectExport/i18n.js